import type { VifDB } from './db.js';
import type { SettingsRecord } from './types.js';

/** Singleton, schema-versioned settings JSON (PRD §10). The payload shape
 * belongs to the shell (M1.3); this layer versions the envelope. */
export const SETTINGS_SCHEMA_VERSION = 1;
const SINGLETON_KEY = 'singleton';

export async function getSettings(db: VifDB): Promise<SettingsRecord> {
  const record = await db.get('settings', SINGLETON_KEY);
  return record ?? { schemaVersion: SETTINGS_SCHEMA_VERSION, data: {} };
}

export async function saveSettings(db: VifDB, data: Record<string, unknown>): Promise<void> {
  const record: SettingsRecord = { schemaVersion: SETTINGS_SCHEMA_VERSION, data };
  await db.put('settings', record, SINGLETON_KEY);
}

/** Shallow merge helper for incremental writes (migration uses this). */
export async function patchSettings(db: VifDB, patch: Record<string, unknown>): Promise<void> {
  const current = await getSettings(db);
  await saveSettings(db, { ...current.data, ...patch });
}
